export default class Collapsible {
  constructor(
    elementSelector = '.swa-collapsible__item',
    collapsibleButtonSelector = '.swa-collapsible__button'
  ) {
    this.elementSelector = elementSelector;
    this.collapsibleButton = collapsibleButtonSelector;
  }

  init() {
    const collapsibleElements = document.querySelectorAll(this.elementSelector);

    if (!collapsibleElements.length) {
      return;
    }

    // Check if the first collapsible content element contains the class 'swa-checkout-product__gift-note-message'
    const firstContent = collapsibleElements[0].querySelector('.swa-collapsible__content');
    const shouldOpenFirst = !firstContent.classList.contains('swa-checkout-product__gift-note-message');

    if (shouldOpenFirst) {
      // Add the 'swa-collapsible-show' class to the first collapsible content element
      firstContent.classList.add('swa-collapsible-show');
    }

    const collapsibleButtons = document.querySelectorAll(this.collapsibleButton);
    // Iterate through all collapsible buttons
    collapsibleButtons.forEach(item => {
      item.addEventListener('click', function() {
        const currentContent = this.parentElement.querySelector('.swa-collapsible__content');
        const isContentVisible = currentContent.classList.contains('swa-collapsible-show');
        for (let i = 0; i < collapsibleElements.length; i++) {
          // Get the content of each collapsible element
          const content = collapsibleElements[i].querySelector('.swa-collapsible__content');
          // Remove the 'swa-collapsible-show' class from the content
          content.classList.remove('swa-collapsible-show');
          collapsibleButtons[i].classList.remove("collapsed");
        }
        if (!isContentVisible) {
          // Add the 'swa-collapsible-show' class to the content of the collapsible element that was clicked
          currentContent.classList.add('swa-collapsible-show');
          this.classList.add("collapsed");
        } else {
          this.classList.remove("collapsed");
        }
      });
    });
  }
}
